export const isValidYtUrl = (url: string) => {
  return /www.youtube.com\/[A-z0-9]+/.test(url)
}
